/**
 * generate a random string to bust the cache based on the current time
 * @returns {string}
 */

function getCacheBusterString() {
    const coeff = 1000 * 60 * 5; // Round to nearest 5 minute increment
    const date = new Date();
    return new Date(Math.ceil(date / coeff) * coeff).getTime().toString();
}

window['getCacheBusterString'] = getCacheBusterString;
